<template class="updates_page" id="1">
  <v-containter class="pagea">

    <div class="aa">

    <center>
      <div>
        <h1>Xsint Updates</h1>
        <p >Xsint is constantly evolving.</p>
        <br><br>
      </div>
    </center>


    <br>

  <center>

      <div class="cupdates" style="width: 90%;">
        <v-row align="center" justify="center" class="updates">
          <v-col
            v-for="(update, index) in updates.slice(0, 6)"
            :key="index"
            cols="12"
            sm="6"
            md="4"
          >
              <v-card class="mx-auto update-card" v-bind="props" :class="{'hovered-card': isHovering}">

              <v-list-item three-line>
              <div class="mb-4 card-date" v-if="update.date" style="max-width: 130px;">
                {{ update.date }}
              </div>

                <v-card-title class="card-title">{{ update.title }}</v-card-title>
                
                <v-list-item-avatar
                  tile
                  size="80"
                  :src="update.image || 'https://via.placeholder.com/80'"
                  color="grey lighten-2"
                ></v-list-item-avatar>


                <v-card-text class="full-text">
                  <div class="description">
                    <p>{{ update.description }}</p>
                  </div>
                </v-card-text>


                <br>
                <img v-if="update.image" :src="'data:image/png;base64,' + update.image"  width="45px"/>

              </v-list-item>
              </v-card>
          </v-col>
        </v-row>
      </div>

    </center>
    </div>
  </v-containter>

</template>

  
<style>
.aa{
  margin-top: 23%;
}

.pagea{
  justify-content: center; 
    align-items: center; 
    height: 100vh; 
    
    align-items: center;
}

.update-card {
  padding: 16px;
  border-radius: 5px;
  background-color: rgba(53, 53, 53, 0.753);
  transition: all 0.7s ease-in-out;
  max-height: 135px;
}

.card-date{
  padding: 5px;
  background-color: rgba(0, 119, 255, 0.507);
  border-radius: 10px;
  color: #bbbbbb;
}

@media only screen and (max-width: 600px) {
  .cupdates {
    max-width: 100%;
  }


}

@media only screen and (min-width: 600px) {
  .cupdates {
    max-width: 90%;
  }

  .aa{
    margin-top: 11%;
  }


  .card-date{
    padding: 5px;
    background-color: rgb(17, 17, 17);
    border-radius: 10px;
    color: #bbbbbb;
  }

  .update-card {
    padding: 16px;
    border-radius: 5px;
    background-color: rgba(92, 92, 92, 0.103);
    transition: all 0.7s ease-in-out;
    max-height: 135px;
  }
}

@media only screen and (min-width: 992px) {
  .cupdates {
    max-width: 100%;
  }

}



.v-btn {
  margin-top: 10px;
}

/* Styles pour les cartes */


.update-card:hover{
  transition: 1.5s;
  max-height: 700px;
}

/* Animation et effet de survol */
.hovered-card {
  transition: 0.7s;
  transform: scale(1.05); /* Agrandissement au survol */
}

.card-title {
  font-weight: bold;
  color: #f5f5f5; /* Texte clair sur fond sombre */
}




</style>

 <script setup>
 /* eslint-disable */
 import { useHead } from '@vueuse/head';
 
 useHead({
   title: 'Updates | XSINT Intelligence',
   meta: [
     { name: 'keywords', content: 'OSINT updates, Xsint Updates, XSINT, OSINT, Investigation tools, Affordable OSINT tools, Investigative software pricing, OSINT packages' },
     { property: 'og:title', content: 'Updates | XSINT Intelligence' },
     { name: 'twitter:title', content: 'Updates | XSINT Intelligence' },
     { name: 'description', content: 'Xsint Update Lists.' },
     { property: 'og:description', content: 'Xsint Update Lists.' },
     { name: 'twitter:description', content: 'Xsint Update Lists.' },
     { property: 'og:type', content: 'website' },
     { property: 'og:url', content: 'https://www.xsint-intelligence.com/updates' },
     { name: 'robots', content: 'index, follow' },
     { name: 'author', content: 'XSINT Intelligence' }
   ]
 });


 
 </script>
 
 <script>
 /* eslint-disable */
 import { mapGetters } from 'vuex';
 
 export default {
   data() {
     return {
       isAuthentified: localStorage.getItem('Authorization') !== null,
       updates: [{title: "Loading..."},{title: "Loading..."},{title: "Loading..."},{title: "Loading..."},{title: "Loading..."},
       {title: "Loading..."},{title: "Loading..."},{title: "Loading..."},{title: "Loading..."}
       ],
     };
   },
   created() {
     this.getUpdates();
   },
   computed: {
     ...mapGetters(['backend']),
   },
   methods: {
     async getUpdates() {
       try {
         const response = await this.$axios.get(`${this.backend}/api/informations/updates`);
         this.updates = response.data.reverse().map(update => ({
           ...update,
           isOpen: false // initialisation de l'état de déploiement
         }));
       } catch (error) {
         console.error("Error fetching updates:", error);
       }
     },
   }
 }
 </script>
 